import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import amplitude from "../utils/amplitude";

export default function LoadingScreen2 () {
  const navigate = useNavigate();

  useEffect(() => {
    // Установка CSS переменной --vh для корректной высоты экрана
    function setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setVh();
    window.addEventListener('resize', setVh);

    // Amplitude и таймер перехода
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Started', {
        option: "loading-2"
      });
      amplitude.track('Session Start', { platform: 'web' });
    }
    const timer = setTimeout(() => {
      navigate("/quiz1");
    }, 3000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', setVh);
    };
  }, [navigate]);

  return (
    <div
      className="max-w-[450px] w-full mx-auto p-4 text-center font-sans bg-white flex flex-col justify-between border rounded-lg shadow-md"
      style={{ minHeight: 'calc(var(--vh, 1vh) * 100)' }}
    >
      {/* Заголовок */}
      <div className="pt-4">
        <h1 className="text-lg md:text-xl font-semibold">
          See how quickly you can achieve<br /> your skincare goals with Solvi
        </h1>
      </div>

      {/* Изображение */}
      <div className="relative w-full h-72 flex justify-center items-center mb-14">
        {/* Сердечко под картинкой */}
        <img
          src="/heart.svg"
          alt="Heart"
          className="absolute left-5 animate-heartSwing z-0"
        />

        {/* Девушка поверх сердечка */}
        <img
          src="/loading2.webp"
          alt="Skincare"
          className="object-cover top-7 left-1 rounded-lg relative z-10"
        />
      </div>

      {/* Лоадер и текст */}
      <div className="p-5 shadow-md overflow-hidden bg-white rounded-xl">
        <p className="font-medium text-md text-gray-700 mb-2">
          Please don't close this page
        </p>
        <div className="w-3/4 h-2 bg-gray-200 rounded-full mx-auto overflow-hidden">
          <div 
            className="bg-pinkCustom h-full rounded-full"
            style={{
              animation: "loadingAnimation 3s forwards",
              width: "0%"
            }}
          />
        </div>
        <p className="text-sm text-gray-600 mt-2">
          Analyzing your skincare profile
        </p>
      </div>

      {/* Подвал */}
      <div className="text-[10px] text-gray-500 px-2 pb-4">
        Solvi: AI-powered personal skincare insights, cutting-edge analytical
        tools, and daily educational articles to keep you informed and glowing.
      </div>


<style>
        {`
          @keyframes loadingAnimation {
            to { width: 100%; }
          }

          @keyframes heartSwing {
            0% { transform: rotate(-20deg); }
            50% { transform: rotate(20deg); }
            100% { transform: rotate(-20deg); }
          }

          .animate-heartSwing {
            animation: heartSwing 2s infinite ease-in-out;
          }
        `}
      </style>
      
    </div>
  );
};
